import * as code from '../code';
import * as ropc from '../ropc';
import { env } from '../utils';

/**
 * Hook to use to get the correct handles for logging in.
 */
export const useProfile = (() => {
  if (env.FLOW === 'code') {
    return code.useProfile;
  }

  if (env.FLOW === 'ropc') {
    return ropc.useProfile;
  }

  throw new Error('@boss/auth is incorrectly configured.');
})();

export default useProfile;
